module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('figure'), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Width :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.width),
      expression: "data.width",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "width",
      "name": "width"
    },
    domProps: {
      "value": (_vm.data.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.width = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Height :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.height),
      expression: "data.height",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "height",
      "name": "height"
    },
    domProps: {
      "value": (_vm.data.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.height = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ticket strip Height :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.coverHeight),
      expression: "data.coverHeight",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "coverHeight",
      "name": "coverHeight"
    },
    domProps: {
      "value": (_vm.data.coverHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.coverHeight = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ticket strip Y :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.coverY),
      expression: "data.coverY",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "coverY",
      "name": "coverY"
    },
    domProps: {
      "value": (_vm.data.coverY)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.coverY = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" mm")])])])]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("x :")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "number",
      "id": "leftClipX",
      "name": "leftClipX"
    },
    domProps: {
      "value": _vm.data.leftClip.x + _vm.data.width / 2
    },
    on: {
      "input": function (e) { return (_vm.data.leftClip.x = Number.parseFloat(e.target.value, 10) - _vm.data.width / 2); }
    }
  }), _vm._v("\n                    mm\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("y :")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "number",
      "id": "leftClipY",
      "name": "leftClipY"
    },
    domProps: {
      "value": _vm.data.height / 2 - _vm.data.leftClip.y
    },
    on: {
      "input": function (e) { return (_vm.data.leftClip.y = -Number.parseFloat(e.target.value, 10) + _vm.data.height / 2); }
    }
  }), _vm._v("\n                    mm\n                ")])])])]), _vm._v(" "), _c('table', [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("x :")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "number",
      "id": "rightClipX",
      "name": "rightClipX"
    },
    domProps: {
      "value": _vm.data.width / 2 - _vm.data.rightClip.x
    },
    on: {
      "input": function (e) { return (_vm.data.rightClip.x = -Number.parseFloat(e.target.value, 10) + _vm.data.width / 2); }
    }
  }), _vm._v("\n                    mm\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("y :")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "number",
      "id": "rightClipY",
      "name": "rightClipY"
    },
    domProps: {
      "value": _vm.data.height / 2 - _vm.data.rightClip.y
    },
    on: {
      "input": function (e) { return (_vm.data.rightClip.y = -Number.parseFloat(e.target.value, 10) + _vm.data.height / 2); }
    }
  }), _vm._v("\n                    mm\n                ")])])])]), _vm._v(" "), _c('table', [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("is bottom adhesive :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.data.rightClip.bottomAdhesive),
      expression: "data.rightClip.bottomAdhesive",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "id": "bottomAdhesive",
      "name": "bottomAdhesive"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.rightClip.bottomAdhesive) ? _vm._i(_vm.data.rightClip.bottomAdhesive, null) > -1 : (_vm.data.rightClip.bottomAdhesive)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.data.rightClip.bottomAdhesive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm._n(null),
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.data.rightClip.bottomAdhesive = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.data.rightClip.bottomAdhesive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.data.rightClip.bottomAdhesive = $$c
        }
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dimensions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Left anchor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Right anchor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Misc")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a2eda7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/shelf-form.vue
// module id = 3162
// module chunks = 0